import { BaseLogo } from "../../../../core/models/entities/BaseLogo";
import { enviroment } from "../../../../enviroment";
import {
  isLogoUploadPending,
  isUploadKindPending,
} from "../../../../utils/functions/productPending";
import { hasGenuineHighRes } from "./keepSharp";

// Flag REACT_APP_CLONE_INSTANT_SHARP_WAIT - pure helpers for the "sharp
// wait" of an instant clone: the state in which the editor must not stretch
// the source's small thumbnail over the canvas, and the faster re-read
// schedule that fetches the clone's own high-res while it lasts.

// Re-read schedule while the clone is upload-pending without a genuine
// high-res: 2, 2, 3, 3, 5, 5, 5, 5 s between calls - 8 calls, 30 s in total.
// The clone worker lands p50 in ~3-5 s (Upload_Base64 1.5 s + colour replay
// ~1 s) and stores the high-res right before it clears the stamp, so the
// second or third call normally carries it; the tail covers a slow supplier.
export const SHARP_WAIT_POLL_MS: readonly number[] = [
  2_000, 2_000, 3_000, 3_000, 5_000, 5_000, 5_000, 5_000,
];

// The one extra GetLogo after uploadPending clears WITHOUT a high-res in
// that response: the API stores the high-res just before it clears the
// stamp, so a poll can observe the cleared stamp a moment before the image
// is readable - one call 1 s later closes that window.
export const SHARP_WAIT_EXTRA_MS = 1_000;

// The delay before re-read number `attempt` (0-based), or undefined when the
// budget is spent. Pure so the schedule can be unit-tested without timers.
export function sharpWaitPollDelay(
  attempt: number,
  delays: readonly number[] = SHARP_WAIT_POLL_MS
): number | undefined {
  if (!Number.isInteger(attempt) || attempt < 0) return undefined;
  if (attempt >= delays.length) return undefined;
  return delays[attempt];
}

// The "sharp wait" state: the open logo is a clone the worker still owes
// (uploadPending, flag cloneInstantEnabled) AND what the canvas holds is not
// a genuine high-res (a seed that carries only the source's thumbnail, marked
// pending by the clone flow; or a GetLogo that answered low-res only).
// A clone seeded with its source's genuine high-res is never in this state -
// it opens on the full canvas as before. Flag off = always false.
// "Upload stands alone" (flag REACT_APP_UPLOAD_PENDING_ENABLED): a
// worker-owned UPLOAD is never in the sharp wait - the editor paints the
// user's own file (raster) or a file card (vector) and runs its own re-read
// (useEditorUploadKindPoll); the skeleton and the 2/2/3/3/5/5/5/5 s clone
// re-read stand down for it. Flag off = the predicate is false = unchanged.
export function isSharpWaitActive(logo: BaseLogo | null | undefined): boolean {
  if (!enviroment.cloneInstantSharpWaitEnabled) return false;
  if (!isLogoUploadPending(logo)) return false;
  if (isUploadKindPending(logo)) return false;
  return !hasGenuineHighRes(logo?.displayImage);
}
